import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { CardActionButton as CompiledCardActionButton } from './cardActionButton-compiled';
import { CardActionButton as EmotionCardActionButton } from './cardActionButton-compiled';
export var CardActionButton = /*#__PURE__*/forwardRef(function (props, ref) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledCardActionButton, _extends({}, props, {
    ref: ref
  })) : /*#__PURE__*/React.createElement(EmotionCardActionButton, _extends({}, props, {
    ref: ref
  }));
});